export const GET_REGISTRATION_REQUESTS_REQUEST =
  "GET_REGISTRATION_REQUESTS_REQUEST";

export const GET_REGISTRATION_REQUESTS_RESPONSE =
  "GET_REGISTRATION_REQUESTS_RESPONSE";

export const GET_COMPANY_DETAILS_REQUEST = "GET_COMPANY_DETAILS_REQUEST";
export const GET_COMPANY_DETAILS_SUCCESS = "GET_COMPANY_DETAILS_SUCCESS";
export const GET_COMPANY_DETAILS_FAILURE = "GET_COMPANY_DETAILS_FAILURE";
export const CLEAR_COMPANY_DETAILS = "CLEAR_COMPANY_DETAILS";
